// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_ST_Internal = require("../Control.Monad.ST.Internal/index.js");
var Data_Array_ST = require("../Data.Array.ST/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Bounded = require("../Data.Bounded/index.js");
var Data_Enum = require("../Data.Enum/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Effect = require("../Effect/index.js");
var Random_LCG = require("../Random.LCG/index.js");
var Random = function (Ord0, random, randomR) {
    this.Ord0 = Ord0;
    this.random = random;
    this.randomR = randomR;
};
var randomsF = function (dictRandom) {
    return function (f) {
        return function (i) {
            return function (seed) {
                var fill = function (arr) {
                    return function __do() {
                        var v = Control_Monad_ST_Internal["new"](seed)();
                        return Control_Monad_ST_Internal["for"](0)(i)(function (v1) {
                            return function __do() {
                                var v2 = Control_Monad_ST_Internal.read(v)();
                                var rp = f(v2);
                                Data_Functor["void"](Control_Monad_ST_Internal.functorST)(Control_Monad_ST_Internal.write(rp.newSeed)(v))();
                                return Data_Functor["void"](Control_Monad_ST_Internal.functorST)(Data_Array_ST.push(rp.newVal)(arr))();
                            };
                        })();
                    };
                };
                return Data_Array_ST.withArray(fill)([  ])();
            };
        };
    };
};
var randomR = function (dict) {
    return dict.randomR;
};
var randomREff = function (dictRandom) {
    return function (min) {
        return function (max) {
            return Control_Bind.bindFlipped(Effect.bindEffect)((function () {
                var $24 = Control_Applicative.pure(Effect.applicativeEffect);
                var $25 = randomR(dictRandom)(min)(max);
                return function ($26) {
                    return $24((function (v) {
                        return v.newVal;
                    })($25($26)));
                };
            })())(Random_LCG.randomSeed);
        };
    };
};
var randomRs = function (dictRandom) {
    return function (min) {
        return function (max) {
            return randomsF(dictRandom)(randomR(dictRandom)(min)(max));
        };
    };
};
var random = function (dict) {
    return dict.random;
};
var randomEff = function (dictRandom) {
    return Control_Bind.bindFlipped(Effect.bindEffect)((function () {
        var $27 = Control_Applicative.pure(Effect.applicativeEffect);
        var $28 = random(dictRandom);
        return function ($29) {
            return $27((function (v) {
                return v.newVal;
            })($28($29)));
        };
    })())(Random_LCG.randomSeed);
};
var randomInt = new Random(function () {
    return Data_Ord.ordInt;
}, function (seed) {
    var newSeed = Random_LCG.lcgNext(seed);
    return {
        newVal: Random_LCG.unSeed(newSeed),
        newSeed: newSeed
    };
}, function (min) {
    return function (max) {
        return function (seed) {
            if (min > max) {
                return randomR(randomInt)(max)(min)(seed);
            };
            if (Data_Boolean.otherwise) {
                var rp = random(randomInt)(seed);
                var newVal = Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(rp.newVal)((max - min | 0) + 1 | 0) + min | 0;
                return {
                    newVal: newVal,
                    newSeed: rp.newSeed
                };
            };
            throw new Error("Failed pattern match at Random.PseudoRandom (line 33, column 1 - line 42, column 55): " + [ min.constructor.name, max.constructor.name, seed.constructor.name ]);
        };
    };
});
var randomChar = new Random(function () {
    return Data_Ord.ordChar;
}, function (seed) {
    var intRp = randomR(randomInt)(0)(65535)(seed);
    var newVal = Data_Enum.toEnumWithDefaults(Data_Enum.boundedEnumChar)(Data_Bounded.bottom(Data_Bounded.boundedChar))(Data_Bounded.top(Data_Bounded.boundedChar))(intRp.newVal);
    return {
        newVal: newVal,
        newSeed: intRp.newSeed
    };
}, function (min) {
    return function (max) {
        return function (seed) {
            if (min > max) {
                return randomR(randomChar)(max)(min)(seed);
            };
            if (Data_Boolean.otherwise) {
                var intRp = randomR(randomInt)(Data_Enum.fromEnum(Data_Enum.boundedEnumChar)(min))(Data_Enum.fromEnum(Data_Enum.boundedEnumChar)(max))(seed);
                var newVal = Data_Enum.toEnumWithDefaults(Data_Enum.boundedEnumChar)(Data_Bounded.bottom(Data_Bounded.boundedChar))(Data_Bounded.top(Data_Bounded.boundedChar))(intRp.newVal);
                return {
                    newVal: newVal,
                    newSeed: intRp.newSeed
                };
            };
            throw new Error("Failed pattern match at Random.PseudoRandom (line 70, column 1 - line 81, column 60): " + [ min.constructor.name, max.constructor.name, seed.constructor.name ]);
        };
    };
});
var randomNumber = new Random(function () {
    return Data_Ord.ordNumber;
}, function (seed) {
    var intRp = random(randomInt)(seed);
    var newVal = Data_Int.toNumber(intRp.newVal) / Data_Int.toNumber(Random_LCG.lcgM);
    return {
        newVal: newVal,
        newSeed: intRp.newSeed
    };
}, function (min) {
    return function (max) {
        return function (seed) {
            if (min > max) {
                return randomR(randomNumber)(max)(min)(seed);
            };
            if (Data_Boolean.otherwise) {
                var rp = random(randomNumber)(seed);
                var newVal = rp.newVal * (max - min) + min;
                return {
                    newVal: newVal,
                    newSeed: rp.newSeed
                };
            };
            throw new Error("Failed pattern match at Random.PseudoRandom (line 44, column 1 - line 55, column 47): " + [ min.constructor.name, max.constructor.name, seed.constructor.name ]);
        };
    };
});
var randomBoolean = new Random(function () {
    return Data_Ord.ordBoolean;
}, function (seed) {
    var numRp = random(randomNumber)(seed);
    var newVal = numRp.newVal > 0.5;
    return {
        newVal: newVal,
        newSeed: numRp.newSeed
    };
}, function (min) {
    return function (max) {
        return function (seed) {
            if (min > max) {
                return randomR(randomBoolean)(max)(min)(seed);
            };
            if (Data_Boolean.otherwise) {
                var rp = random(randomBoolean)(seed);
                var newVal = rp.newVal && max || min;
                return {
                    newVal: newVal,
                    newSeed: rp.newSeed
                };
            };
            throw new Error("Failed pattern match at Random.PseudoRandom (line 57, column 1 - line 68, column 41): " + [ min.constructor.name, max.constructor.name, seed.constructor.name ]);
        };
    };
});
var randoms = function (dictRandom) {
    return function (i) {
        return randomsF(dictRandom)(random(dictRandom))(i);
    };
};
module.exports = {
    Random: Random,
    random: random,
    randomR: randomR,
    randoms: randoms,
    randomRs: randomRs,
    randomEff: randomEff,
    randomREff: randomREff,
    randomInt: randomInt,
    randomNumber: randomNumber,
    randomBoolean: randomBoolean,
    randomChar: randomChar
};
